import classNames from 'classnames';
import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import AccordionList from './ClientExperienceAccordionList';


function ClientExperienceRoot({ classes, ...rest }) {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Client Experience Page',
    isPageView: true,
  });

  return (
    <div className={classNames(classes.root)} {...rootNodeProps} {...rest}>
      <AccordionList />
    </div>
  );
}

export default withStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}))(ClientExperienceRoot);
